export const REDIRECT_TO_CONFIG_PAGE = {
  CLICK_COUNT: 10,
  DIFF_TIME_CONSTRAINT: 10,
  DIFF_TIME_CONSTRAINT_UNIT: 'second',
} as const;

export const POPUP_ANIMATION_DURATION_SECOND = {
  FADE: 0.2,
  UNMOUNT: 0.1,
} as const;

export const APP_INIT_LOADING_DURATION_SECOND = 1.5;

export const MODAL_CLOSING_COUNTDOWN_SECOND = 3;

export const NOT_FOUND_PAGE_REDIRECT_COUNTDOWN_SECOND = 3;

export const MESSAGE_SHOW_DURATION_SECOND = 1.5;
